import './PaymentSuccess.css';
import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useSetRecoilState } from 'recoil';
import { navigationBarState } from '../../states/NavigationBar';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

function PaymentFail() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const setNavigationBarState = useSetRecoilState(navigationBarState);

    const errorCode = searchParams.get('code');
    const errorMessage = searchParams.get('message');

    useEffect(() => {
        setNavigationBarState(null);
    }, []);

    const handleGoBack = () => {
        navigate(-1);
    };

    return (
        <div className="payment-result-container">
            <div className="payment-result-information">
                <div className="payment-result-error-icon">
                    <ErrorOutlineIcon style={{ fontSize: 98, color: '#DC2626' }} />
                </div>
                <div className="payment-result-title">결제 실패</div>
                <div className="payment-result-description">
                    {errorMessage || '결제가 취소되었거나 실패했습니다.'}
                    {errorCode && (
                        <div style={{ marginTop: 8, fontSize: 12, color: '#9CA3AF' }}>
                            오류 코드: {errorCode}
                        </div>
                    )}
                </div>
            </div>
            <div
                className="payment-result-confirm-button ripple-key-color"
                onClick={handleGoBack}
            >
                돌아가기
            </div>
        </div>
    );
}

export default PaymentFail;
